exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sb-attendance .description-vaccine_name{text-transform:capitalize}.sb-attendance .sb-reference-values-table div.refrence-value-cell{margin-top:8px;padding:8px;background-color:rgba(0,0,0,.08)}.sb-attendance .sb-reference-values-table div.refrence-value-cell p{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sb-attendance .sb-medical-request-image{max-width:300px;max-height:300px;margin:10px auto 0;border-radius:6px;box-shadow:1px 2px 3px 0 rgba(0,0,0,.1);width:100%}.sb-attendance .sb-health-insurance-img{width:304px;height:188.97px;margin:10px auto 0;border:1px solid #ddd;border-radius:6px;background-color:#fff;box-shadow:1px 2px 3px 0 rgba(0,0,0,.1)}md-dialog-content .sb-medical-request-image-dialog{width:600px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/attendance/attendance.scss
// module id = 484
// module chunks = 0